var _rect, _rect2, _mask, _path, _path2, _rect3, _rect4, _mask2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompetitorsDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.328107,
    y: 0.00467923,
    width: 0.46486,
    height: 6.61845,
    rx: 0.23243,
    transform: "matrix(0.715919 -0.698183 0.695718 0.718315 4.24864 11.3241)",
    fill: "#56627C",
    stroke: "#909BB3",
    strokeWidth: 0.46486
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.328107,
    y: 0.00467923,
    width: 0.46486,
    height: 6.61845,
    rx: 0.23243,
    transform: "matrix(0.715919 -0.698183 0.695718 0.718315 3.51964 12.0595)",
    fill: "#56627C",
    stroke: "#909BB3",
    strokeWidth: 0.46486
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_534_2611",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.5498 12.6797L7.64435 14.8274L4.78068 17.6202C4.38529 18.0058 3.75217 17.9978 3.36658 17.6024L2.66839 16.8865C2.2828 16.4911 2.29074 15.858 2.68613 15.4724L5.5498 12.6797Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5498 12.6797L7.64435 14.8274L4.78068 17.6202C4.38529 18.0058 3.75217 17.9978 3.36658 17.6024L2.66839 16.8865C2.2828 16.4911 2.29074 15.858 2.68613 15.4724L5.5498 12.6797Z",
    stroke: "#909BB3",
    strokeWidth: 3,
    mask: "url(#path-3-inside-1_534_2611)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.28483 12.3347L13.443 3.58473L18.0521 2.58179L16.9339 7.16432L8.03122 14.1236",
    stroke: "#909BB3",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.00456384,
    y: -0.328109,
    width: 0.46486,
    height: 6.61845,
    rx: 0.23243,
    transform: "matrix(-0.698435 -0.715674 0.71807 -0.695971 11.3405 15.9468)",
    fill: "#56627C",
    stroke: "#909BB3",
    strokeWidth: 0.46486
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.00456384,
    y: -0.328109,
    width: 0.46486,
    height: 6.61845,
    rx: 0.23243,
    transform: "matrix(-0.698435 -0.715674 0.71807 -0.695971 12.0773 16.6753)",
    fill: "#56627C",
    stroke: "#909BB3",
    strokeWidth: 0.46486
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-2_534_2611",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6826 15.1084L14.8296 13.0131L17.4459 15.6939C17.8316 16.0891 17.8239 16.7223 17.4286 17.108L16.7129 17.8064C16.3177 18.1922 15.6846 18.1844 15.2988 17.7892L12.6826 15.1084Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6826 15.1084L14.8296 13.0131L17.4459 15.6939C17.8316 16.0891 17.8239 16.7223 17.4286 17.108L16.7129 17.8064C16.3177 18.1922 15.6846 18.1844 15.2988 17.7892L12.6826 15.1084Z",
    stroke: "#909BB3",
    strokeWidth: 3,
    mask: "url(#path-7-inside-2_534_2611)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.81528 9.90249L3.58573 7.21816L2.58118 2.60938L7.1641 3.72599L9.81528 6.40249",
    stroke: "#909BB3",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4586 14.5433L11.2368 13.3154",
    stroke: "#909BB3",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1626 12.3955L13.1577 11.4004",
    stroke: "#909BB3",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitorsDark);
export default __webpack_public_path__ + "static/media/competitors-dark.c6ad8c78d304a98d2c2c615b1486b9e6.svg";
export { ForwardRef as ReactComponent };